// NOTE: add window-is-locked class to html markup

const locker = {

  IS_IOS(){
    return /iPad|iPhone|iPod/.test(navigator.platform);
  },

  lockScreen() {
    // if ( /iPad|iPhone|iPod/.test(navigator.platform)) {
    //   return;
    // }
  // NOTE:
  // html.window-is-locked {
  //     overflow: hidden;
  //     -ms-touch-action: none;
  //     touch-action: none;
  // }
    let d=document;
    let $html = d.getElementsByTagName('html')[0];
    let lockedClass = 'window-is-locked';
    let paddingRight;
    let $body = d.getElementsByTagName('body')[0];
    let modul = 1;

    if (!$html.classList.contains(lockedClass)) {
      $html.classList.add(lockedClass);
    } else {
      $html.classList.remove(lockedClass);
      modul = -1
    }
    paddingRight = parseInt(window.getComputedStyle($body, null).getPropertyValue('padding-right'), 10) + this.getScrollbarWidth() * modul;
    $body.style.paddingRight = paddingRight + 'px';
    // console.log('paddingRight', paddingRight);
  },

  unlockScreen() {
    this.lockScreen()
  },

  getScrollbarWidth() {

    let w=window,
        d=document,
        e=d.documentElement,
        g=d.getElementsByTagName('body')[0],
        h=d.getElementsByTagName('html')[0],
        wWidth=w.innerWidth||e.clientWidth||g.clientWidth,
        wHeght=w.innerHeight||e.clientHeight||g.clientHeight,
        dHeight = Math.max(g.scrollHeight, g.offsetHeight, g.getBoundingClientRect().height, h.clientHeight, h.scrollHeight, h.offsetHeight);

    if (dHeight <= wHeght) {
      return 0;
    }

    let outer = document.createElement('div');
    let inner = document.createElement('div');
    let widthNoScroll;
    let widthWithScroll;

    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    document.body.appendChild(outer);

    widthNoScroll = outer.offsetWidth;

    // Force scrollbars
    outer.style.overflow = 'scroll';

    // Add inner div
    inner.style.width = '100%';
    outer.appendChild(inner);

    widthWithScroll = inner.offsetWidth;

    // Remove divs
    outer.parentNode.removeChild(outer);

    return widthNoScroll - widthWithScroll;
  }

}

export { locker };